
import Slider from "react-slick";
import React, { useEffect, useState } from "react";
import HomeService from "../../../Services/HomeService";
import img from "../../../Images/Group 7.png"
import {
    FaCheckCircle,
    FaMapMarkerAlt,
    FaBed,
    FaBath,
    FaArrowRight,
} from "react-icons/fa";
import "./MoreProperty.css";

const MoreProperty = ({ property }) => {

    const [propertyByLocality, setPropertyByLocality] = useState([]);

    const fetchPropertyByLocality = async () => {

        try {

            if (!property?.locality?._id) {
                console.log("No locality id found");
                return;
            }

            const res = await HomeService.getPropertiesByLocality(
                property?.locality?._id
            );

            console.log("Property By Locality", res);

            const filteredProperties =
                res?.data?.filter(
                    (item) => item?._id !== property?._id
                ) || [];

            if (filteredProperties?.length > 6) {
                setPropertyByLocality(
                    filteredProperties.slice(0, 6)
                );
            } else {
                setPropertyByLocality(filteredProperties);
            }

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {

        if (property?.locality?._id) {
            fetchPropertyByLocality();
        }

    }, [property]);

    const propertySlider = {
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: false,

        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                },
            },

            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };


    const firstPhoto = property?.images?.find((url) =>
        /\.(jpg|jpeg|png|webp)$/i.test(url),
    );


    return (
        <div className="spd2-wrapper">

            {/* ===========================
         RERA SECTION
      =========================== */}

            <div className="spd2-rera-box">

                <div className="spd2-rera-left">
                    <div className="spd2-rera-badge">
                        <FaCheckCircle />
                        <span>RERA approved</span>
                    </div>

                    <h3>What is RERA?</h3>

                    <p>
                        The Real Estate (Regulation and Development) Act,
                        2016 protects home buyers and improves transparency
                        in the real estate industry.
                    </p>

                    <div className="spd2-rera-id">
                        <h5>RERA ID</h5>
                        <span>
                            WBRERA/P/NOR/2025/003627
                        </span>
                    </div>
                </div>

                <div className="spd2-rera-logo">
                    <div className="spd2-rera-circle">
                        R
                    </div>
                </div>
            </div>

            {/* ===========================
         SPECIFICATION SECTION
      =========================== */}

            <div className="spd2-spec-box">

                <h2>
                    Specifications of {property?.projectName || "Property"}
                </h2>

                <div className="spd2-spec-scroll">

                    <div className="spd2-spec-grid">

                        <div className="spd2-spec-item">
                            <h4>Foundation</h4>

                            <p>
                                Reinforced cement concrete structure
                            </p>
                        </div>

                        <div className="spd2-spec-item">
                            <h4>Kitchen</h4>

                            <p>
                                Granite platform with stainless steel sink
                            </p>

                            <p>
                                Electrical points for refrigerator &
                                chimney
                            </p>
                        </div>

                        <div className="spd2-spec-item">
                            <h4>Wall Finish</h4>

                            <p>
                                Premium waterproof exterior paint
                            </p>

                            <p>
                                Interior plaster with smooth finish
                            </p>
                        </div>

                        <div className="spd2-spec-item">
                            <h4>Flooring</h4>

                            <p>
                                Vitrified tiles in bedroom & living area
                            </p>
                        </div>

                        <div className="spd2-spec-item">
                            <h4>Bathroom</h4>

                            <p>
                                Anti-skid ceramic flooring with branded
                                fittings
                            </p>
                        </div>

                        <div className="spd2-spec-item">
                            <h4>Security</h4>

                            <p>
                                CCTV surveillance & intercom facility
                            </p>
                        </div>

                    </div>

                </div>
            </div>

            <div className="spd2-more-property">

                <div className="spd2-title-row">
                    <div>
                        <p className="spd2-mini-title">
                            Nearby Recommended
                        </p>

                        <h2>
                            More in {property?.locality?.name}
                        </h2>
                    </div>

                    <button className="spd2-view-all-btn">
                        View All
                        <FaArrowRight />
                    </button>
                </div>

                <div className="spd2-slider-wrapper">

                    {propertyByLocality?.length > 0 ? (

                        <Slider {...propertySlider}>

                            {propertyByLocality?.map((e, i) => (

                                <div className="spd2-slide" key={e?._id || i}>

                                    <div className="spd2-property-card">

                                        <div className="spd2-property-img">
                                                {/* "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJ6Pd1wMuv7nKtspwQ_Qi6BEp2l5xE8735kw&s" */}
                                            <img
                                                src={
                                                    e?.images?.find((url) =>
                                                        /\.(jpg|jpeg|png|webp)$/i.test(url),
                                                    ) ||img
                                                }
                                                alt=""
                                            />

                                        </div>

                                        <div className="spd2-property-content">

                                            <h3>
                                                {e?.projectName || "Premium Apartment"}
                                            </h3>

                                            <p>
                                                {e?.address || "New Town, Kolkata"}
                                            </p>

                                            <h4>
                                                ₹{e?.price || "1.5 Cr"}
                                            </h4>

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </Slider>

                    ) : (

                        <div className="spd2-no-property">
                            No Property Found
                        </div>

                    )}

                </div>

            </div>

        </div>
    );
};

export default MoreProperty;